import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as shareLib from 'libs/shareLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'share/INITIAL_STORE';
const RELOAD_SHARE = 'share/RELOAD_SHARE';
const GET_SHARE = 'share/GET_SHARE';
const ADD_SHARE_USER = 'share/ADD_SHARE_USER';
const CANCEL_SHARE_USER = 'share/CANCEL_SHARE_USER';
const CANCEL_SHARE_SERVICE = 'share/CANCEL_SHARE_SERVICE';
const CHANGE_SHARE_SERVICE = 'share/CHANGE_SHARE_SERVICE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const reloadShare = createAction(RELOAD_SHARE);
export const getShare = createAction(GET_SHARE, shareLib.getShare);
export const addShareUser = createAction(ADD_SHARE_USER, shareLib.addShareUser);
export const cancelShareUser = createAction(CANCEL_SHARE_USER, shareLib.cancelShareUser);
export const cancelShareService = createAction(CANCEL_SHARE_SERVICE, shareLib.cancelShareService);
export const changeShareService = createAction(CHANGE_SHARE_SERVICE, shareLib.changeShareService);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [RELOAD_SHARE]: (state, action) => {
      return state.set('needReload', true);
    },
    ...pender({
      type: GET_SHARE,
      onSuccess: (state, action) => {
        const { data } = action.payload;

        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('indexByNo', fromJS(normal.listIndexByNo(data.list, 'userServiceNo')));
      },
      onFailure: (state, action) => {
        console.log('GET_SHARE 실패');
      }
    }),
    ...pender({
      type: ADD_SHARE_USER,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('ADD_SHARE_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: CANCEL_SHARE_USER,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('CANCEL_SHARE_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: CANCEL_SHARE_SERVICE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('CANCEL_SHARE_SERVICE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: CHANGE_SHARE_SERVICE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('CHANGE_SHARE_SERVICE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/share.js